/* eslint-disable @typescript-eslint/no-var-requires */
import type { AppDispatch } from 'src/types/store';

export const clearPostHogProps = (): void => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('ph_phc_')) {
      localStorage.removeItem(key);
    }
  });

  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith('ph_phc_')) {
      sessionStorage.removeItem(key);
    }
  });
};

export const clearOnLogout = (dispatch?: AppDispatch): void => {
  if (dispatch) {
    // Lazy imports to avoid circular dependency with store
    const { baseApi } = require('src/services/base.api');
    const { selectManagedAccountId } = require('src/store/slices/companySlice');
    const { setProjectId } = require('src/store/slices/projectsSlices');
    const { clearOnboardingState } = require('src/store/slices/onboardingSlice');
    dispatch(baseApi.util.resetApiState());
    dispatch(selectManagedAccountId(''));
    dispatch(setProjectId({ projectId: null, projectType: null }));
    dispatch(clearOnboardingState());
  }

  localStorage.removeItem('COMPANY_ID');
  localStorage.removeItem('user');
  localStorage.removeItem('tokens');
  localStorage.removeItem('LATEST_VIEWED_PROJECT_ID');
  sessionStorage.removeItem('environment');

  // Lazy import to avoid circular dependency: clear.util → store → services → base.api → clear.util
  const { persistor } = require('src/store/store');
  persistor.flush().then(() => {
    return persistor.purge();
  });
};
